import DispatchContext from '@app/contexts/DispatchContext.js';
import StateContext from 'contexts/StateContext.js';
import { useCallback, useContext, useEffect, useRef } from 'react';

const useStudioTracking = () => {
	const dispatch = useContext(DispatchContext);
	const { studioGlobalTracking } = useContext(StateContext);
	const studioGlobalTrackingRef = useRef(studioGlobalTracking);
	useEffect(() => {
		studioGlobalTrackingRef.current = studioGlobalTracking;
	}, [studioGlobalTracking]);

	const wrapDefaults = useCallback(
		(data) => ({
			timestamp: new Date().toISOString(),
			clientId: studioGlobalTrackingRef.current.identity.clientId,
			accountId: studioGlobalTrackingRef.current.identity.accountId,
			userId: studioGlobalTrackingRef.current.identity.userId,
			...data,
		}),
		[]
	);

	const updateTrackingState = useCallback((payload) => {
		dispatch({
			type: 'updateGlobalTracking',
			payload,
		});
	}, []);

	const getTrackingData = useCallback((category, key) => {
		return studioGlobalTrackingRef.current[category][key];
	}, []);

	return {
		studioTrackingData: studioGlobalTrackingRef.current,
		getTrackingData,
		wrapDefaults,
		updateTrackingState,
	};
};

export default useStudioTracking;
